import { colors } from '../../tokens/colors.js'

export const EDITOR_STYLES = {
  '& .editor > *': {
    fontFamily: 'Geist',
    marginBottom: 14,
  },
  '& table': {
    width: '100%',
  },
  '& td': {
    borderBottom: `1px solid ${colors.neutral20}`,
  },
  '& h1': {
    fontSize: 28,
    fontWeight: 600,
    lineHeight: 1.1,
    letterSpacing: 28 * -0.02,
  },
  '& h2': {
    fontSize: 22,
    fontWeight: 500,
    lineHeight: 1.25,
    letterSpacing: '0.22px',
  },
  '& h3': {
    fontSize: 18,
    fontWeight: 500,
    lineHeight: 1.37,
    letterSpacing: '0.36px',
  },
  '& p': {
    fontSize: 14,
    fontWeight: 300,
    lineHeight: 1.62,
    letterSpacing: '0.42px',
  },
  '& blockquote': {
    fontSize: 14,
    fontWeight: 300,
    lineHeight: 1.25,
    letterSpacing: 28 * 0.01,
    borderLeft: `2px solid ${colors.neutral20}`,
    paddingLeft: 14,
  },
  '& ol, & ul': {
    padding: '0 0 0 16px',
  },
  '& li, & li::marker': {
    fontSize: 14,
    fontWeight: 300,
    lineHeight: 1.25,
    letterSpacing: '0.42px',
  },
  '& .editor-link': {
    color: colors.purple100,
    textDecoration: 'none',
  },
  '& .italic': {
    fontStyle: 'italic',
  },
  '& a:hover, & .underline': {
    textDecoration: 'underline',
  },
  '& .strikethrough': {
    textDecoration: 'line-through',
  },
  '& .underline-strikethrough': {
    textDecoration: 'underline line-through',
  },
}
